import { Injectable, inject } from '@angular/core'
import { Filter, Pageable, RestClientPaged } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ProcessPlan } from './process-plan'
import { combineLatest, Observable } from 'rxjs'
import { map, shareReplay } from 'rxjs/operators'

export class ProcessPlanFilter {
  public static ids(processPlanIds: string[] | string): Filter {
    return new Filter('ids', processPlanIds)
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProcessPlanService extends RestClientPaged<ProcessPlan, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private _processPlanCache$: Observable<ProcessPlan[]>

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/process-plans', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public get processPlans$(): Observable<ProcessPlan[]> {
    if (!this._processPlanCache$) {
      this._processPlanCache$ = this.findAllPaged(new Pageable(0, 100)).pipe(
        map((page) => page.content),
        shareReplay(1)
      )
    }
    return this._processPlanCache$
  }

  public fetchByIds$(involvedProcessPlanIds$: Observable<string[]>): Observable<ProcessPlan[]> {
    return combineLatest([this.processPlans$, involvedProcessPlanIds$]).pipe(
      map(([allPlans, involvedPlanIds]) =>
        allPlans.filter((pp) => involvedPlanIds.indexOf(pp.id) >= 0)
      )
    )
  }
}
